import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
// EX2-347: environment (no .development) para que fileReplacements aplique el de cada build.
import { environment } from './environments/environment';

if (environment.prod == false) {
  console.log('BUILD NRO 1111');
} else {
  // EX2-347: en PROD no mostrar en la consola del navegador las respuestas
  // completas que se loguean en ~150 lugares. console.error y warn siguen.
  console.log = () => {};
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
